import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../Context/UserContext/index.tsx';
import './style.css';

const MCQPage = () => {
  const { courseId, username, batchNo } = useAuth();
  const { id } = useParams();
 const navigate = useNavigate();
  const [mcqData, setMcqData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [userAnswers, setUserAnswers] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);

  const questionSetId = `M${id}MCQ`;
  const submittedKey = `mcq_${id}_submitted_ids`;

  useEffect(() => {
    const fetchMCQs = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`https://elearn-api.onrender.com/api/questions/${courseId}`);
        setMcqData(response.data);
      } catch (err) {
        setError('Failed to fetch MCQs');
      } finally {
        setLoading(false);
      }
    };
    fetchMCQs();
  }, [courseId]);

  const filteredMcqs = useMemo(() => {
    return mcqData.filter(mcq => mcq.QuestionSetId === questionSetId);
  }, [mcqData, questionSetId]);

  // Find first unanswered question index and set currentIndex there on load
  useEffect(() => {
    const submittedIds = JSON.parse(localStorage.getItem(submittedKey)) || [];

    if (filteredMcqs.length > 0) {
      const firstUnansweredIndex = filteredMcqs.findIndex(
        q => !submittedIds.includes(q.QuestionId)
      );
      setCurrentIndex(firstUnansweredIndex === -1 ? 0 : firstUnansweredIndex);
    }
  }, [filteredMcqs]);

  // Get submittedIds from localStorage (to use in render)
  const submittedIds = JSON.parse(localStorage.getItem(submittedKey) || '[]');

  // Identify the first unanswered index for button logic
  const firstUnansweredIndex = filteredMcqs.findIndex(
    q => !submittedIds.includes(q.QuestionId)
  );

  // Hide Previous button if current question is the first unanswered question
  const hidePrevButton = currentIndex === firstUnansweredIndex;

  const handleAnswerChange = (questionId, selectedOption) => {
    setUserAnswers(prev => ({
      ...prev,
      [questionId]: selectedOption,
    }));
  };

  const submitSingleAnswer = async (question) => {
    const selectedOption = userAnswers[question.QuestionId];
    if (!selectedOption) return;

    const submittedIds = JSON.parse(localStorage.getItem(submittedKey)) || [];
    if (submittedIds.includes(question.QuestionId)) {
      return; // Already submitted
    }

    const selectedAnswerText = question[`Option_${selectedOption.toLowerCase()}`];
    const answerPayload = {
      NricID: username,
      CourseID: courseId,
      QuestionSetId: question.QuestionSetId,
      QuestionId: question.QuestionId,
      question: question.question,
      Selected_Option: selectedAnswerText,
      SelectedAnswer: selectedAnswerText,
      BatchNo: batchNo,
    };

    try {
      const response = await axios.post('https://elearn-api.onrender.com/api/insertQuestionAttempt', answerPayload, {
        headers: { 'Content-Type': 'application/json' },
      });
      console.log('Submitted question:', response.data);

      // Save question as submitted
      const updatedSubmittedIds = [...submittedIds, question.QuestionId];
      localStorage.setItem(submittedKey, JSON.stringify(updatedSubmittedIds));
    } catch (error) {
      console.error('Error submitting question:', error.response?.data || error);
      alert('Failed to submit question.');
    }
  };

  const handleNext = async () => {
    const currentQuestion = filteredMcqs[currentIndex];
    await submitSingleAnswer(currentQuestion);
    if (currentIndex < filteredMcqs.length - 1) {
      setCurrentIndex(prev => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(prev => prev - 1);
    }
  };

  const handleSubmit = async () => {
    const currentQuestion = filteredMcqs[currentIndex];
    await submitSingleAnswer(currentQuestion);

    // Mark MCQ set as completed
    localStorage.setItem(`mcq_${id}_completed`, 'true');
    localStorage.setItem(`module_${parseInt(id) + 1}_unlocked`, 'true');
    localStorage.removeItem(submittedKey); // Clean up

    window.dispatchEvent(new Event('storage')); // Sync sidebar, etc.
    navigate('/course-info');
    alert('Final answer submitted successfully!');
  await fetch(`https://elearn-api.onrender.com/api/increment-currentsts/${username}/${batchNo}/${courseId}`, {
        method: 'POST',
      });
  
  };

  if (!id) return <div>Invalid MCQ Set ID.</div>;
  if (loading) return <div>Loading MCQs...</div>;
  if (error) return <div>{error}</div>;

  const currentQuestion = filteredMcqs[currentIndex];

  return (
    <div className="mcq-page">
      <h1>MCQ Set {id}</h1>

      {filteredMcqs.length === 0 ? (
        <p>No questions found for this set.</p>
      ) : !currentQuestion ? (
        <p>Question not found.</p>
      ) : (
        <div className="question-block">
          <h3>Q{currentIndex + 1}. {currentQuestion.question}</h3>
          <ul>
            {['A', 'B', 'C', 'D'].map(option => {
              const isSubmitted = submittedIds.includes(currentQuestion.QuestionId);
              return (
                <li key={option}>
                  <label>
                    <input
                      type="radio"
                      name={`question_${currentQuestion.QuestionId}`}
                      value={option}
                      checked={userAnswers[currentQuestion.QuestionId] === option}
                      onChange={() => handleAnswerChange(currentQuestion.QuestionId, option)}
                      disabled={isSubmitted} // disable if already submitted
                    />
                    {option}. {currentQuestion[`Option_${option.toLowerCase()}`]}
                  </label>
                </li>
              );
            })}
          </ul>

          <div className="navigation-buttons">
            {/* {!hidePrevButton && (
              <button onClick={handlePrev} disabled={currentIndex === 0}>
                Previous
              </button>
            )} */}

            {currentIndex < filteredMcqs.length - 1 ? (
              <button
                onClick={handleNext}
                disabled={!userAnswers[currentQuestion.QuestionId]}
              >
                Next
              </button>
            ) : (
              <button
                onClick={handleSubmit}
                disabled={!userAnswers[currentQuestion.QuestionId]}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MCQPage;
